var classof = require('../internals/classof-raw');

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// ./~/react-stickynode/~/core-js/internals/is-array.js
// module id = 451
// module chunks = 0